import { render, staticRenderFns } from "./iconBtn.vue?vue&type=template&id=00c1b723&scoped=true"
import script from "./iconBtn.vue?vue&type=script&lang=js"
export * from "./iconBtn.vue?vue&type=script&lang=js"
import style0 from "./iconBtn.vue?vue&type=style&index=0&id=00c1b723&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c1b723",
  null
  
)

export default component.exports